import axios from 'axios';
import { getCurrentInstance, ref, onMounted } from "vue";
// console.log(app.config.globalProperties.$cookies.get('username'))


// import qs from 'qs';
const config_env = require(`../../build/${process.env.BUILD_ENV}.js`)
// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = config_env.BASE_URL;
// } else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = config_env.BASE_URL;
// } else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = config_env.BASE_URL;
// }
// 请求拦截器
axios.interceptors.request.use(config => {
    //向请求头添加token，username
    // var that = this
    let user = JSON.parse($cookies.get('login'))
    if (user != null) {
        
        return config
    } else {
        config.headers.common = {
            "clientId": "datapid",
            "secret": 'e10adc3949ba59abbe56e057f20f883e',
            "Accept-Language": 'zh,zh',
            "username": ''
        }
        return config
    }
}, error => {
    return Promise.reject(error);
})
// axios.interceptors.response.use((response) => {

//   const res = response.data
//   console.log(res)

//   if (res.code == 500) {

//     ElementUI.Message({
//       message: res.message,
//       type: 'warning'
//     });
//   }
//   if (res.code != 200) {
//     if (res.code == 401 || res.code == 403) {
//       ElementUI.Message({ type: 'danger', message: '请登录' });
//     }
//     // console.log(res)
//     return response
//     // return Promise.reject()
//   } else {
//     return response
//   }
// })
export default axios;